export enum TrackActionTypes {
    API_RESPONSE_SUCCESS = '@@track/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@track/API_RESPONSE_ERROR',

    LIST_ADSET_TRACKS = '@@track/LIST_TRACKS',
    LIST_ADSET_TIMELINE = '@@track/LIST_TIMELINE',

    RESET = '@@track/RESET',
}
